export enum COOKIE_NAMES {
  CookieConsent = "cookie_consent"
}
